// const AJAX_URL = '/wp-admin/admin-ajax.php'

jQuery(document).foundation();
jQuery(document).ready(function($) {

  // Menu Dropdown Wrapper
  $(".menu-wrapper > .menu-item").each(function(index) {
		$(this).next(".sub-sub-menu").andSelf().wrapAll("<div class='inner' />")
	});

  // Event Listeners for Homepage About Tags
  $( ".folderflip_tag" ).each(function(index) {
    $(this).on("click", function(e){
      e.preventDefault();

      var heroHeight = $('.hero.home').outerHeight(true);
      var introHeight = $('.intro').outerHeight(true);
      var heightBefore = heroHeight + introHeight;
      // console.log('heightBefore', heightBefore)

      var previousElementsHeight = 0;

      var previousElements = $(this).prevAll('.folderflip_folder');
      previousElements.each(function(){
        previousElementsHeight += $(this).outerHeight(true);
      });

      // console.log('previousElements', previousElements)
      // console.log('previousElementsHeight', previousElementsHeight)

      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        $("html, body").animate(
          {
            scrollTop: heightBefore + previousElementsHeight
          },
          250
        );
        return false;
      }
    });
  });

  //Segments Application Slider
  if ($(".application-slider").length > 0) {
    $(".application-slider").slick({
      centerMode: true,
      centerPadding: '26%',
      slidesToShow: 1,
      dots: true,
      arrows: true,
      prevArrow: $('.slick-prev'),
      nextArrow: $('.slick-next'),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: true,
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: true,
            dots: false,
            centerMode: false,
            slidesToShow: 1
          }
        }
      ]
    });
    $('.application-slider').on('init', function(event, slick){
      ScrollTrigger.refresh();
    });
  }

   //Application Landing Slider
   if ($(".applications-slider").length > 0) {
    $(".applications-slider").slick({
      slidesToShow: 3,
      dots: false,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      prevArrow: $('.slick-prev'),
      nextArrow: $('.slick-next'),
      responsive: [
        {
          breakpoint: 820,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
    $('.applications-slider').on('init', function(event, slick){
      ScrollTrigger.refresh();
    });
  }

   //Fasteners Slider
   if ($(".fasteners-slider").length > 0) {
    $(".fasteners-slider").slick({
      slidesToShow: 3,
      dots: false,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      prevArrow: $('.slick-prev'),
      nextArrow: $('.slick-next'),
      responsive: [
        {
          breakpoint: 820,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
    $('.fasteners-slider').on('init', function(event, slick){
      ScrollTrigger.refresh();
    });
  }

  //Threads Slider
  if ($(".threads-slider").length > 0) {
    $(".threads-slider").slick({
      slidesToShow: 1,
      dots: false,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      fade: true,
      speed: 0,
      prevArrow: $('.slick-prev-thread'),
      nextArrow: $('.slick-next-thread'),
    });
    $('.threads-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      const hexs = document.querySelectorAll('.hex-bg');

      if (nextSlide > currentSlide) {
        if (hexs) {
          hexs.forEach((el) => {
              gsap.to(el, {
                rotation: "+=60",
              })
          })
        }
      } else {
        if (hexs) {
          hexs.forEach((el) => {
              gsap.to(el, {
                rotation: "-=60",
              })
          })
        }
      }
    });
    $('.threads-slider').on('init', function(event, slick){
      ScrollTrigger.refresh();
    });
  }

  // Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
    if ($(this).innerWidth() / $(this).innerHeight() > 1.5) {
        $(this).wrap("<div class='widescreen flex-video'/>");
    } else {
        $(this).wrap("<div class='flex-video'/>");
    }
  });

  //Smooth Scroll
  $('a[href*="#"]:not([role="tab"]):not(.skip-anchor):not(.folderflip_tag)').on("click", function() {
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      console.log(target)
      if (target.length) {
        $("html, body").animate(
          {
            scrollTop: target.offset().top - 125
          },
          1000
        );
        return false;
      }
    }
  });
  //Smooth Scroll on page load if hash
  var hash = window.location.hash;
  if (hash) {
    var target = $(hash);
    target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
    if (target.length) {
      $("html, body").animate(
        {
          scrollTop: target.offset().top - 125
        },
        1000
      );
      return false;
    }
  }

  var showMenus = (function() {
    var executed = false;
    return function() {
      if (!executed) {
        // executed = true;
        $("#menu-top-menu li").each(function(index) {
          $(this)
            .delay(200 * index)
            .queue(function() {
              $(this)
                .addClass("shown")
                .dequeue();
            });
        });
      }
    };
  })();

  $(".off-canvas").on("opened.zf.offcanvas", function(e) {
    $(".hamburger").toggleClass("is-active");
    $("body").toggleClass("menu-opened");
  });
  $(".off-canvas").on("closed.zf.offcanvas", function(e) {
    $(".hamburger").toggleClass("is-active");
    $("body").toggleClass("menu-opened");
  });

  //Slugify function
  function slugify(string) {
    const a = "àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœṕŕßśșțùúüûǘẃẍÿź·/_,:;";
    const b = "aaaaaaaaceeeeghiiiimnnnoooooprssstuuuuuwxyz------";
    const p = new RegExp(a.split("").join("|"), "g");
    return string
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, "-and-") // Replace & with ‘and’
      .replace(/[^\w\-]+/g, "") // Remove all non-word characters
      .replace(/\-\-+/g, "-") // Replace multiple - with single -
      .replace(/^-+/, "") // Trim - from start of text
      .replace(/-+$/, ""); // Trim - from end of text
  }
});
